import { propertyMeta, typeMeta, MetaTypesBase } from "@/autogen/common";

export const PrinterStaffSearchParamsMetaFields = {
  printerMACExact: propertyMeta("printerMACExact", false, false, false, MetaTypesBase.string),
  printerMACAnyOf: propertyMeta("printerMACAnyOf", true, false, false, MetaTypesBase.string),
  printerMACLike: propertyMeta("printerMACLike", false, false, false, MetaTypesBase.string),
  printerNameExact: propertyMeta("printerNameExact", false, false, false, MetaTypesBase.string),
  printerNameAnyOf: propertyMeta("printerNameAnyOf", true, false, false, MetaTypesBase.string),
  printerNameLike: propertyMeta("printerNameLike", false, false, false, MetaTypesBase.string),
  createdOnExact: propertyMeta("createdOnExact", false, false, false, MetaTypesBase.Date),
  createdOnAnyOf: propertyMeta("createdOnAnyOf", true, false, false, MetaTypesBase.Date),
  createdOnLess: propertyMeta("createdOnLess", false, false, false, MetaTypesBase.Date),
  createdOnLessEq: propertyMeta("createdOnLessEq", false, false, false, MetaTypesBase.Date),
  createdOnGreater: propertyMeta("createdOnGreater", false, false, false, MetaTypesBase.Date),
  createdOnGreaterEq: propertyMeta("createdOnGreaterEq", false, false, false, MetaTypesBase.Date),
  createdByExact: propertyMeta("createdByExact", false, false, false, MetaTypesBase.string),
  createdByAnyOf: propertyMeta("createdByAnyOf", true, false, false, MetaTypesBase.string),
  createdByLike: propertyMeta("createdByLike", false, false, false, MetaTypesBase.string),
  updatedOnExact: propertyMeta("updatedOnExact", false, false, false, MetaTypesBase.Date),
  updatedOnAnyOf: propertyMeta("updatedOnAnyOf", true, false, false, MetaTypesBase.Date),
  updatedOnLess: propertyMeta("updatedOnLess", false, false, false, MetaTypesBase.Date),
  updatedOnLessEq: propertyMeta("updatedOnLessEq", false, false, false, MetaTypesBase.Date),
  updatedOnGreater: propertyMeta("updatedOnGreater", false, false, false, MetaTypesBase.Date),
  updatedOnGreaterEq: propertyMeta("updatedOnGreaterEq", false, false, false, MetaTypesBase.Date),
  updatedByExact: propertyMeta("updatedByExact", false, false, false, MetaTypesBase.string),
  updatedByAnyOf: propertyMeta("updatedByAnyOf", true, false, false, MetaTypesBase.string),
  updatedByLike: propertyMeta("updatedByLike", false, false, false, MetaTypesBase.string),
};

export const PrinterStaffSearchParamsMeta = typeMeta("PrinterStaffSearchParams", PrinterStaffSearchParamsMetaFields);
